import { Chain, Connector, ConnectorData } from 'wagmi';
import { ExtensionProvider } from '@multiversx/sdk-extension-provider';
import { IMultiverxSigner, MultiverxSigner } from './MultiversXSigner';
import { ELROND_CHAIN_ID } from '../helpers/customChains';
import {
  WalletsName,
  WalletsType,
} from '../components/ConnectedWallet/wallets.ls';

export class MultiverxConnector extends Connector<any> {
  readonly id = WalletsType.MultiversX;
  readonly name = WalletsName.MultiversX;
  readonly ready = true;
  // readonly chains =

  provider: ExtensionProvider;
  signer: IMultiverxSigner | undefined;

  constructor(chains: Chain[]) {
    super({ chains, options: {} });

    this.provider = ExtensionProvider.getInstance();
    this.provider.init().then((ok) => {
      if (ok) {
        this.signer = new MultiverxSigner(this.provider);
        console.log('MultiversX connector successfully initiated');
      } else {
        console.log("MultiversX connector cann't be initiated");
      }
    });
  }

  async getProvider(config?: { chainId?: number }) {
    return this.provider;
  }

  async connect(config?: {
    chainId?: number;
  }): Promise<Required<ConnectorData>> {
    await this.provider.login();
    const { signature, address } = this.provider.account;

    return {
      account: address,
      chain: {
        id: ELROND_CHAIN_ID,
        unsupported: false,
      },
      provider: this.provider,
    } as Required<ConnectorData>;
  }

  async disconnect(): Promise<void> {
    await this.provider.logout();
  }

  async getAccount(): Promise<`0x${string}`> {
    const { signature, address } = this.provider.account;
    return address as any;
  }

  async getChainId(): Promise<number> {
    return ELROND_CHAIN_ID;
  }

  async getWalletClient(config?: { chainId?: number }): Promise<any> {
    return this.signer;
  }

  async isAuthorized(): Promise<boolean> {
    return this.provider.isConnected();
  }

  protected onAccountsChanged(accounts: `0x${string}`[]): void {
    throw new Error('Method onAccountsChanged not implemented.');
  }

  protected onChainChanged(chain: string | number): void {
    throw new Error('Method onChainChanged not implemented.');
  }

  protected async onDisconnect(error: Error) {
    await this.provider.logout();
  }
}
